import { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { 
  RPC_URL, 
  PRESALE_WALLET_ADDRESS, 
  BALANCE_REFRESH_INTERVAL
} from '../utils/constants';

/**
 * Hook to fetch and monitor the presale wallet balance
 */
const useWalletBalance = () => {
  const [walletBalance, setWalletBalance] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    let isMounted = true;
    let intervalId = null;
    
    const fetchWalletBalance = async () => {
      try {
        if (!PRESALE_WALLET_ADDRESS) {
          throw new Error('Presale wallet address not configured');
        }
        
        setIsLoading(true);
        
        // Initialize provider
        const provider = new ethers.JsonRpcProvider(RPC_URL);
        
        // Get wallet balance
        const balanceWei = await provider.getBalance(PRESALE_WALLET_ADDRESS);
        const balanceEth = parseFloat(ethers.formatEther(balanceWei));
        
        console.log(`Fetched wallet balance: ${balanceEth} ETH`);
        
        if (isMounted) {
          setWalletBalance(balanceEth);
          setError(null);
        }
      } catch (err) {
        console.error('Error fetching wallet balance:', err);
        if (isMounted) {
          setError(`Failed to fetch wallet balance: ${err.message}`);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };
    
    // Initial fetch
    fetchWalletBalance();
    
    // Set up interval for refreshing
    intervalId = setInterval(fetchWalletBalance, BALANCE_REFRESH_INTERVAL);
    
    // Cleanup
    return () => {
      isMounted = false;
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);
  
  return {
    totalContributedEth: walletBalance,
    isLoadingBalance: isLoading,
    error
  };
};

export default useWalletBalance;